import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductNameComponent } from './product-name.component';
import { CmsConfig, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [ProductNameComponent],
  imports: [CommonModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductName: {
          component: ProductNameComponent,
        },
      },
    }),
  ],
})
export class ProductNameModule {}
